import React, { useState, useEffect } from 'react';

import Container         from 'react-bootstrap/Container';
import '../App.css';
import portrait          from './portrait.module.css';
import landscape         from './home.module.css';
import pic_home          from '../pictures/Backdrop Image.avif';
import pic_home_portrait from '../pictures/Backdrop Image Portrait.avif';
import { Context }       from '../services/context.js';
import { Helmet }        from 'react-helmet';

import cx from 'classnames';

const notice_text  = <>How to make Stable Coins?  See our publication: <span style={{color: 0xff0000}}> Money for Modern Times 🎉</span></>
const cx_header    = cx({ [portrait.header]: Context.portrait, [landscape.header]: !Context.portrait });
const cx_text      = cx({ [portrait.text]: Context.portrait, [landscape.text]: !Context.portrait });
const cx_ul        = cx({ [portrait.ul]: Context.portrait, [landscape.ul]: !Context.portrait });
const cx_li        = cx({ [portrait.li]: Context.portrait, [landscape.li]: !Context.portrait });
const cx_text_wide = cx([landscape.text_wide]);

export default function Home(props) {
  const [showNotice, setShowNotice] = useState(true);
  const [contentDisabled, setContentDisabled] = useState(false); // ← state must live here

  /* Hide the banner once the CSS animation is over (12 s total) */
  useEffect(() => {
    const t = setTimeout(() => setShowNotice(false), 9000);
    return () => clearTimeout(t);
  }, []);

  //-----------------------------------------------------------
  //  Event handler toggles overlay visibility
  //-----------------------------------------------------------
  const changeVisible = (mode) => {
    setContentDisabled(mode);
    //console.log('contentDisabled', mode);
  };

  //------------------------------------------------------
  // Simple wrapper for the animated notice banner
  //------------------------------------------------------
  function Notice({ children }) 
  {
    const cls = Context.portrait ? portrait.notice : landscape.notice;
    return <div className={cls}>{children}</div>;
  }

  //------------------------------------------------------
  //  Render
  //------------------------------------------------------
  if (Context.portrait) {
    return (
      <div className={portrait.backdrop}>
        <Helmet>
          <title>Home page</title>
          <meta name="description" content="Shows Singapore—the place Back‑Step Blockchain was invented." />
        </Helmet>

        {/* background image */}
        <img src={pic_home_portrait} alt="Backdrop" />

        {/* notice */}
        {showNotice && <Notice>Welcome to Back‑Step&nbsp;Blockchain&nbsp;</Notice>}
      </div>
    );
  }

  // — landscape —
  return (
    <div
      className={landscape.backdrop}
      onMouseDown={()     => changeVisible(true)}
      onMouseUp={()       => changeVisible(false)}
      onContextMenu={(e)  => e.preventDefault()}
    >
      <Helmet>
        <title>Home page</title>
        <meta name="description" content="Shows Singapore—the place Back‑Step Blockchain was invented." />
      </Helmet>

      {/* background image */}
      <img src={pic_home} alt="Backdrop" />

      {/* notice */}
      {showNotice && <Notice> How to make Stable Coins?  See our publication: <span style={{color: 'red'}}> Money for Modern Times 🎉</span> </Notice>}

      {/* optional overlay */}
      {contentDisabled && <div className={landscape.overlay} />}
    </div>
  );
}


